module.exports = __webpack_public_path__ + "static/Barnes-and-noble-booksellers-logo-34f85772a9aa5536e6f69c4310a6249e.png";